import api from './api.config';

// User APIs
export const userAPI = {
  getAllUsers: async (params = {}) => {
    const response = await api.get('/users', { params });
    return response.data;
  },
  
  getAll: async (params = {}) => {
    const response = await api.get('/users', { params });
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/users/${id}`);
    return response.data;
  },

  update: async (id, data) => {
    const response = await api.put(`/users/${id}`, data);
    return response.data;
  },

  deactivate: async (id) => {
    const response = await api.delete(`/users/${id}`);
    return response.data;
  },

  reactivate: async (id) => {
    const response = await api.put(`/users/${id}/reactivate`);
    return response.data;
  },

  changeRole: async (id, role) => {
    const response = await api.put(`/users/${id}/role`, { role });
    return response.data;
  },

  getStats: async () => {
    const response = await api.get('/users/stats');
    return response.data;
  }
};

export default userAPI;
